export function setAttendanceTracking(postFn) {
  const selectedStatus = localStorage.getItem("selectedStatus");
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");

  if (selectedStatus && auth?.user?.id && typeof postFn === "function") {
    return postFn("/setAttendancePublic", {
      type: selectedStatus,
      label: "stop",
      userId: auth.user.id,
    })
      .catch(() => {})
      .finally(() => {
        localStorage.removeItem("selectedStatus");
        localStorage.removeItem("breakLogsStartTime");
      });
  }

  localStorage.removeItem("selectedStatus");
  localStorage.removeItem("breakLogsStartTime");
  return Promise.resolve();
}

